export function getExerciseDisplay(exercise, t, options) {
    const { exerciseName, isEachSide } = exercise;
    if (!isEachSide)
        return exerciseName;
    return `${exerciseName}${options?.abbreviated ? ' (ea)' : ` (${t('eachSide')})`}`;
}
//# sourceMappingURL=exercise-display.js.map